// Copyright (c) Microsoft. All rights reserved.

import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogSurface,
    DialogTitle,
    makeStyles,
    mergeClasses,
    shorthands,
 
    
} from '@fluentui/react-components';
import React from 'react';
import { customColors, customFonts } from '../../styles';

const useClasses = makeStyles({
    root: {
        width: '450px',
        borderRadius: '15px',
    },
    actions: {
        paddingTop: '10%',
    },
    delete: {
        backgroundColor: customColors.protivitiOrange,
        "&:hover": {
            backgroundColor: customColors.summarizeButtonDarker,
            color: customColors.white
        }
    },
    close: {
        backgroundColor: customColors.white,
        "&:hover": {
            backgroundColor: customColors.summarizeButtonDarker,
            color: customColors.white
        }
    },
    button: {
        fontFamily: customFonts.Lato,
        fontSize: '12px',
        borderRadius: '5px',
        ...shorthands.border('1.5px', 'solid', customColors.protivitiOrange),

    },
    title: {
        fontFamily: customFonts.TitleFont,
        fontWeight: '500',
        fontSize: '24px'
    }
});

interface ConfirmationDialogProps {
    message: string;
    onNoDialog: () => void;
    onYesDialog: () => void;
    className?: string;
    confirmButtonText?: string;
}

export const ConfirmDialog: React.FC<ConfirmationDialogProps> = ({ message, onNoDialog, onYesDialog, confirmButtonText }) => {
    const classes = useClasses();

    return (
            <Dialog
            // this controls the dialog open state
            open={true}
            
          >
            <DialogSurface className={classes.root}>
                <DialogBody>
                    <DialogTitle className={classes.title}> {message}</DialogTitle>
                    <DialogActions className={classes.actions} >
                            <Button 
                                style={{ transition: 'all 0.3s ease' }}
                                className={mergeClasses(classes.close, classes.button)}
                                appearance="secondary" onClick={onNoDialog}>
                                    Cancel
                            </Button>
                            <Button 
                                style={{ transition: 'all 0.3s ease' }}
                                className={mergeClasses(classes.delete, classes.button)} 
                                onClick={onYesDialog}>
                            {confirmButtonText || 'Delete'}
                            </Button> 
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );

};
